import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url:'/notice/list',
    method:'get',
    params:params
  })
}

export function updateDeleteStatus(params) {
  return request({
    url:'/notice/update/deleteStatus',
    method:'post',
    params:params
  })
}

export function create(data) {
  return request({
    url:'/notice/create',
    method:'post',
    data:data
  })
}

export function createBatch(data) {
  return request({
    url:'/notice/createBatch',
    method:'post',
    data:data
  })
}

export function update(id,data) {
  return request({
    url:'/notice/update/'+id,
    method:'post',
    data:data
  })
}

export function updateStatus(params) {
  return request({
    url:'/notice/update/status',
    method:'post',
    params:params
  })
}

export function countUnread(params) {
  return request({
    url:'/notice/countUnread',
    method:'get',
    params:params
  })
}





// WEBPACK FOOTER //
// ./src/api/notice.js